import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueScrollProgress from './plugins/scrollbar';
import App from './App.vue';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
Vue.use(VueScrollProgress);
Vue.use(VueAxios, axios);

new Vue({
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
